module.exports = __webpack_public_path__ + "static/media/modelo.f81b3b70.png";